import * as React from 'react';
import { useRef, useState} from 'react';
import {
    Tooltip, Chip, TextField, Autocomplete, InputLabel, Input, Button, Card, Divider, FormLabel, 
    Stack, Typography, Box, 
} from '@mui/material'
import RemoveIcon from "@mui/icons-material/RemoveCircleOutlineSharp";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowDownAZ, faArrowUpAZ} from '@fortawesome/free-solid-svg-icons'
import RadioIconButtonGroup from '../RadioIconButtonGroup'
import ScheduleIcon from '@mui/icons-material/Schedule';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import GradeIcon from '@mui/icons-material/Grade';
import CountrySelect from '../CountrySelect';

import * as CONSTANTS from "../../constants"
import { MovementCategoriesMapping } from '../../mappings/movementCategories';


const MovementFilter = ({resetFilter, submitFilter, lang}) => {

    const [sortOption, setSortOption] = useState('a_to_z');
    const [categories, setCategories] = useState([]);
    const [name, setName] = useState('');

    // let name = useRef('')

    let tagKeys = []
    for (let index = 1; index <= Object.keys(MovementCategoriesMapping).length; index++) {
        tagKeys.push(index);
    }

    const ResetFilter = () => {
        setName('');
        setCategories([]);
        resetFilter();
    }
    
    const GetFilter = () => {
        let params = new URLSearchParams({});
        params.append('page', 1)
        if (name !== '')  params.append('name', name);
        categories.forEach(category => {
            params.append('categories', category);
        });
        params.append('sort', sortOption);
        submitFilter(params);
    };

    return (
        <Card
            sx={{
                borderRadius: 'md',
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                overflow: "auto",
                minWidth: "300px",
            }}
        >
            <Box sx={{ gap: 2 }}>
                <Stack
                    direction={'column'}
                    spacing={2}
                >
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold' }}>{CONSTANTS.WAZAREN_FILTER.SORTING_OPTION[lang]}</FormLabel>
                    <RadioIconButtonGroup 
                        hook={sortOption}
                        setHook={setSortOption}
                        buttonValues={[
                            'a_to_z', 'z_to_a', // 'experience', 'clicks', 'likes', 'ratings',
                        ]}
                        buttonIcons={{
                            'a_to_z': <FontAwesomeIcon icon={faArrowDownAZ} />,
                            'z_to_a': <FontAwesomeIcon icon={faArrowUpAZ} />,
                            'experience': <ScheduleIcon />,
                            'clicks': <VisibilityIcon />,
                            'likes': <ThumbUpIcon />,
                            'ratings': <GradeIcon />,
                        }}
                        buttonDisableds={{
                            'a_to_z': false,
                            'z_to_a': false,
                            'experience': false,
                            'clicks': true,
                            'likes': true,
                            'ratings': true
                        }}
                        tooltipValues={{
                            'a_to_z': 'Name (A to Z)',
                            'z_to_a': 'Name (Z to A)',
                            'experience': 'Experience',
                            'clicks': 'Clicks',
                            'likes': 'Likes',
                            'ratings': 'Ratings'
                        }}
                    />
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold'}}>{CONSTANTS.WAZAREN_FILTER.SEARCHING_OPTION[lang]}</FormLabel>
                    <FormLabel sx={{ typography: 'title-md', fontWeight: 'bold' }}>{CONSTANTS.ORGANIZATION_FILTER.NAME[lang]}</FormLabel>
                    <Input 
                        placeholder={CONSTANTS.WOTAGEISHI_FILTER.NAME_PLACEHOLDER[lang]}
                        value={name}
                        onChange={(e)=> setName(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    <Typography level="title-md" fontWeight="bold" sx={{ mb: 2 }}>{CONSTANTS.MOVEMENT_FILTER.CATEGORIES[lang]}</Typography>
                    <InputLabel>{CONSTANTS.WAZAREN_FILTER.INCLUDE[lang]}</InputLabel>
                    <Stack 
                        className="selectedCategories"
                        direction="row" 
                        spacing={1}
                        useFlexGap
                        flexWrap="wrap"
                    >
                        {
                            categories.map((option, index) => {
                                // This is to handle new options added by the user (allowed by freeSolo prop).
                                const label = MovementCategoriesMapping[option][lang] || option;
                                return (
                                    <Chip 
                                        size="medium"
                                        variant="outlined"
                                        key={option}
                                        label={label}
                                        deleteIcon={<RemoveIcon />} 
                                        onDelete={() => {
                                            setCategories(categories.filter(entry => entry !== option));
                                        }}
                                        sx={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: 'fit-content',
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                        }}
                                    />
                                );
                            })
                        }
                    </Stack>
                    <Autocomplete
                        multiple
                        id="tags-standard"
                        freeSolo
                        filterSelectedOptions
                        options={tagKeys}
                        onChange={(e, newValue) => setCategories(newValue)}
                        getOptionLabel={tagKey => MovementCategoriesMapping[tagKey][lang]}
                        renderTags={() => {}}
                        value={categories}
                        componentsProps={{
                            paper: {
                                sx: { width: '100%' }
                            }
                        }}
                        renderInput={params => (
                        <TextField
                            {...params}
                            variant="standard"
                            placeholder=""
                            margin="normal"
                            fullWidth
                        />
                        )}
                    />
                </Stack>
            </Box>

          <Divider sx={{ mt: 'auto' }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            useFlexGap
            spacing={1}
          >
            <Button
              variant="outlined"
              color="neutral"
              onClick={ResetFilter}
            >
              {CONSTANTS.WAZAREN_FILTER.RESET[lang]}
            </Button>
            <Button
                variant="contained"
                color="primary"
                onClick={GetFilter}
            >
                {CONSTANTS.WAZAREN_FILTER.SEARCH[lang]}
            </Button>
        </Stack>
    </Card>
  );
};

export default MovementFilter;
